import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BinType } from '../location/bintype';
import { BinTypeService } from '../location/bin-type.service';

import { Message, ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'pl-bin-type',
  templateUrl: './bin-type.component.html',
  styleUrls: ['./bin-type.component.css'],
  providers: [ConfirmationService]
})
export class BinTypeComponent implements OnInit {

  binTypeList: BinType[];
  msgs: Message[];
  selectedBinType: BinType;
  testBool : boolean;

  constructor(private bintypeService: BinTypeService, private router: Router,
    private confirmationService: ConfirmationService) {
    this.binTypeList = [];
    this.msgs = [];
    this.selectedBinType = this.createDefaultBinType();
  }

  ngOnInit() {
    this.loadBinTypes();
  }

  private loadBinTypes() {
    this.bintypeService.list().subscribe(
      (bintypeArray: BinType[]) => {
        this.binTypeList = [];
        for (var bintype of bintypeArray)
          this.binTypeList = [...this.binTypeList, bintype];
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of bintypes.' });
      }
    );
  }

  private createDefaultBinType() : BinType {
    let bintype = new BinType();
    bintype.id = -1;

    bintype.name = "";
    bintype.shortname = "";
    bintype.height = 0.1;
    bintype.width = 0.1;
    bintype.length = 0.1;
    bintype.weight = 1;

    bintype.relativeSize = 1;

    bintype.created = new Date();
    bintype.updated = new Date();
    return bintype;
  }

  public addNew() {
    console.log('Create new BinType.');

    /**
     * We need to check first, if there is already a new instance
     * in list of areas.
     */
    for (var a of this.binTypeList) {
      if (a.id < 0) {
        this.selectedBinType = a;
        this.msgs.push({ severity: 'info', summary: 'Erst neuen Typ speichern.' });
        return;
      }
    }

    let bintype = this.createDefaultBinType();

    this.binTypeList = [...this.binTypeList, bintype];
    this.selectedBinType = bintype;
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
  }

  public deleteSelected() {
    console.log("Delete bin type triggered");
    this.msgs = [];
    if (this.selectedBinType == null) {
      console.log("No bin type selected -> return");
      this.msgs.push({ severity: 'info', summary: 'Kein Behältertyp ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie den  Behältertyp wirlich loeschen?',
      accept: () => {
        this.bintypeService.delete(this.selectedBinType.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Behältertyp wurde geloescht.' });
              this.loadBinTypes();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Behältertyp konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Behältertyp konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  /**
   * Saves or updates edited bintype entity to server.
   */
  public onSave() {
    if (this.selectedBinType == null || this.selectedBinType.id == null)
      this.msgs.push({ severity: 'info', summary: 'Please add or selected an bintype first.' });

    if (this.selectedBinType.id == -1) {
      this.bintypeService.save(this.selectedBinType).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Behältertyp wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadBinTypes();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Behältertyp konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save bintype, error msg: ' + err);
        }
      );
    }
    else {
      this.bintypeService.update(this.selectedBinType).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Behältertyp wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadBinTypes();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Behältertyp konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save bintype, error msg: ' + err);
        }
      );
    }
  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/bin-type/bin-type.component.ts